export * from './IconFractureBlue';
